import { render, staticRenderFns } from "./order-view-form.vue?vue&type=template&id=4150c4f1&"
import script from "./order-view-form.ts?vue&type=script&lang=ts&"
export * from "./order-view-form.ts?vue&type=script&lang=ts&"
import style0 from "./order-view-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports